import React, {Component} from 'react';
import { connect } from 'react-redux';
import RegistrationAction from "../../actions/RegistrationAction";
import Preloader from '../Preloader';

class SignupVerify extends Component {

  componentDidMount() {
    if (this.props.params.token) {
      this.props.verifyEmailToken(this.props.params.token);
    }
  }

  render() {
    return (
      <div className="row signup-box">
        <div style={{marginLeft: '100px'}}>
          <Preloader/>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    currentStep: state.currentStep
  }),
  dispatch => ({
    verifyEmailToken: (token) => {
      dispatch(RegistrationAction.verifyEmailToken(token));
    }
  })
)(SignupVerify);


/** WEBPACK FOOTER **
 ** ./src/components/Sign/signup_verify.js
 **/